export default __webpack_public_path__ + "c0745d0a309433dc881857975fcd184d.glb";